import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import FixtureModel from '../models/FixtureModel';

interface FixturePreviewState {
    model: FixtureModel,
    showPreviewPanel: boolean,
}

const initialState: FixturePreviewState = {
    model: {

    } as FixtureModel,
    showPreviewPanel: false,
}

export const FixturePreviewSlice = createSlice({
    name: "FixturePreview",
    initialState,
    reducers: {
        setFixturePreviewModel: (state, action: PayloadAction<FixtureModel>) => {
            state.model = action.payload;
        },
        setShowPreviewPanel: (state, action: PayloadAction<boolean>) => {
            state.showPreviewPanel = action.payload;
        },
    }
});

export const FixturePreviewSelector = createSelector(
    (state: RootState) => state.fixturePreview,
    (data) => data
);

export const {
    setFixturePreviewModel,
    setShowPreviewPanel
} = FixturePreviewSlice.actions;

export default FixturePreviewSlice.reducer;